module.exports = __webpack_public_path__ + "static/media/our-customer.6cea73cb.svg";